import React, {useContext} from 'react';
import Lang from '../Lang/Lang';
import {
  eventEmitter,
  hoverUnderlineClass,
  lang,
  underlineClass,
} from '../../common/baseData';
import {
  ClientWidthContext,
} from '../Context/ApplicationContextProvider';
import Icon from '../Icon/Icon';

function ProductInSearch(props) {
  const {
    ARTICLE,
    DETAIL_PAGE_URL,
    ID,
    NAME,
    OLD_PRICE,
    PICTURE,
    PRICE,
    NALICHIE,
    PRICE_VALUE,
    rootClassName,
    itemKey,
  } = props;

  const clientWidth = useContext(ClientWidthContext);
  const isDesktop = clientWidth >= 1024;

  const isOutOfStock = NALICHIE === 'Нет в наличии' || NALICHIE === 'Немає в наявності';

  const defaultRootClassName = `flex justify-start shrink-0 w-auto gap-5 ${isOutOfStock ? 'opacity-50' : ''}`;

  function getStatusColor(status) {
    switch (status) {
      case 'Нет в наличии':
      case 'Немає в наявності':
        return 'text-[#E52327]'
      case 'Ожидается':
      case 'Очікується':
        return 'text-[#F49423]'
      default:
        return 'text-[#333]'
    }
  }

  // Обработчик клика на товар из автоподсказок
  function handleProductClick(e) {
    try {
      eventEmitter.emit('MSAddClickHistory', { productId: ID });
    } catch (reason) {
      console.error(reason);
    }
  }

  return (
    <li className={rootClassName ? rootClassName : defaultRootClassName}
        key={itemKey}>
      {/*<!-- картинка -->*/}
      <div className="flex items-center justify-center w-20 h-20 desktop:w-25">
        <img src={PICTURE}
             title={NAME}
             alt={NAME}
             className="object-fill w-full h-auto"/>
      </div>
      <div className="flex justify-between mt-1 w-full">
        {/*<!-- наименование -->*/}
        <div>
          <a href={DETAIL_PAGE_URL}
             onClick={handleProductClick}
             className={`text-[13px] h-max leading-[17px] text-black line-clamp-3 desktop:line-clamp-2 desktop:h-[36px] grow-0 ${isDesktop ? hoverUnderlineClass : ''}`}>
            {NAME}
          </a>
          {
            NALICHIE && NALICHIE.length > 0 && (
              <span className={`text-[12px] block mt-1.5 ${getStatusColor(NALICHIE)}`}>{NALICHIE}</span>
            )
          }
        </div>
        <div className="flex flex-col shrink-0 ml-10 w-20">
          {/*<!-- стоимость -->*/}
          {
            OLD_PRICE && OLD_PRICE.length > 0 && (
              <span className="text-[11px] leading-[13px] line-through text-grey-50 decoration-red-line-through">
                {OLD_PRICE}
            </span>
            )
          }
          {
            PRICE_VALUE && PRICE_VALUE > 0 && (
              <span className="text-[14px] leading-[18px] font-medium text-grey-90">
                {PRICE}
              </span>
            )
          }
        </div>
      </div>
    </li>
  );
}

export default ProductInSearch;